import { __rest } from "tslib";
import { Slot } from '@radix-ui/react-slot';
import React from 'react';
import { tv } from 'tailwind-variants';
const link = tv({
    base: [
        'duration-300',
        'ease-smooth',
        'cursor-pointer',
        'transition-all',
        'will-change-transform',
        'focus-visible:rounded-sm',
        'focus-visible:outline',
        'focus-visible:outline-2',
        'focus-visible:outline-offset-4',
    ],
    variants: {
        size: {
            xxs: ['text-xxs', 'tracking-normal'],
            xs: ['text-xs', 'tracking-normal'],
            sm: ['text-sm', 'tracking-normal'],
            base: ['text-base', 'tracking-normal'],
            lg: ['text-lg', 'tracking-normal'],
            xl: ['text-xl', '-tracking-[0.01em]'],
            '2xl': ['text-2xl', '-tracking-[0.01em]'],
            '3xl': ['text-3xl', '-tracking-[0.02em]'],
            '4xl': ['text-4xl', '-tracking-[0.02em]'],
            '5xl': ['text-5xl', '-tracking-[0.02em]'],
            '6xl': ['text-6xl', '-tracking-[0.02em]'],
            '7xl': ['text-7xl', '-tracking-[0.02em]'],
            '8xl': ['text-8xl', '-tracking-[0.03em]'],
            '9xl': ['text-9xl', '-tracking-[0.03em]'],
        },
        variant: {
            primary: [
                'text-blue-700',
                'hover:text-blue-600',
                'focus-visible:outline-gray-900/10',
            ],
            secondary: [
                'text-gray-900',
                'hover:text-gray-500',
                'focus-visible:outline-gray-900/10',
            ],
            muted: [
                'text-gray-500',
                'hover:text-gray-900',
                'focus-visible:outline-gray-900/10',
            ],
            current: [
                'text-current',
                'hover:opacity-70',
                'focus-visible:outline-gray-900/10',
            ],
        },
        underline: {
            // Needs to be important because of legacy global styles targetting the anchor tag directly
            true: ['!underline', '!underline-offset-[3px]'],
            false: [],
        },
        weight: {
            regular: ['font-normal'],
            medium: ['font-medium'],
            semibold: ['font-semibold'],
            bold: ['font-bold'],
        },
    },
    defaultVariants: {
        variant: 'primary',
        weight: 'medium',
        underline: true,
    },
});
function BtwLink(props) {
    const { asChild, children, className, size, underline, variant, weight } = props, rest = __rest(props, ["asChild", "children", "className", "size", "underline", "variant", "weight"]);
    const Comp = asChild ? Slot : 'a';
    return (React.createElement(Comp, Object.assign({ className: link({ className, size, variant, weight, underline }) }, rest), children));
}
export { BtwLink };
